import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import clsx from "clsx";

import BluePattern from "Assets/patterns/blue.json";

import styles from "./styles.module.scss";

import bgBlue from "Assets/background/bg-blue.jpg";
import bgOrange from "Assets/background/bg-orange.jpg";
import bgRed from "Assets/background/bg-red.jpg";
import bgPink from "Assets/background/bg-pink.jpg";

const PatternBackgroundContext = createContext(null);

export const PatternBackgroundProvider = ({ children }) => {
  const canvasRef = useRef(null);
  const appRef = useRef(null);

  const [colors, setColors] = useState({
    primary: BluePattern.color.pattern.value.primary,
    background: BluePattern.color.pattern.value.background,
  });
  const [overlay, setOverlay] = useState(false);
  const [removeOverlay, setRemoveOverlay] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState("transparent");
  const [activeImage, setActiveImage] = useState(bgBlue);

  const handleChangeColors = (
    value: { name: string; background: string; primary: string },
    overlay: boolean,
    backgroundColor: string,
    showPattern = true
  ) => {
    setColors(value);
    setOverlay(overlay);

    if (!showPattern) {
      setActiveImage(null);
      setBackgroundColor(backgroundColor);
      return;
    }

    switch (value.name) {
      case "Blue":
        setActiveImage(bgBlue);
        break;
      case "Orange":
        setActiveImage(bgOrange);
        break;
      case "Red":
        setActiveImage(bgRed);
        break;
      case "Pink":
        setActiveImage(bgPink);
        break;
      default:
        setActiveImage(bgBlue);
    }

    if (backgroundColor) {
      setBackgroundColor(backgroundColor);
    }
  };

  const handleChangeBackground = (value) => {
    setBackgroundColor(value);
  };

  const handleChangePattern = (woneParams, overlay, backgroundColor) => {
    localStorage.setItem("woneParams", JSON.stringify(woneParams));

    if (appRef.current) {
      appRef.current.controls.init();
    }

    setOverlay(overlay);
    if (backgroundColor) {
      setBackgroundColor(backgroundColor);
    }
  };

  useEffect(() => {
    if (appRef.current) {
      appRef.current.controls.parameters.color.pattern.value = colors;
      appRef.current.renderer.instance.setClearColor(colors.background);
      appRef.current.controls.trigger(`parameter-update-color-pattern`);
      appRef.current.controls.updateLocalStorage();
    }
  }, [colors]);

  return (
    <PatternBackgroundContext.Provider
      value={{
        onChangePattern: handleChangePattern,
        onChangeColors: handleChangeColors,
        onChangeBackgroundColor: handleChangeBackground,
        removePatternOverlay: setRemoveOverlay,
      }}
    >
      <div className={clsx(styles.canvas)}>
        <canvas
          ref={canvasRef}
          className={styles.canvas}
          style={{
            backgroundImage: activeImage ? `url(${activeImage})` : "none",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100vw 100vh",
            backgroundColor: backgroundColor,
          }}
        ></canvas>
        <div
          className={clsx(
            !removeOverlay && overlay
              ? styles.overlay
              : removeOverlay
              ? styles.removeOverlay
              : ""
          )}
          style={{ backgroundColor }}
        />
        {children}
      </div>
    </PatternBackgroundContext.Provider>
  );
};

export const usePatternBackground = () => useContext(PatternBackgroundContext);

export default PatternBackgroundProvider;
